/** @jsxImportSource @emotion/react */

import React, { FC, useEffect } from "react";
import { css } from "@emotion/core";
import GridCell from "ui-modules/components/Layout/Grid/GridCell";
import Grid from "ui-modules/components/Layout/Grid/Grid";

const AuthLayout: FC = ({ children }) => {
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, "", window.location.href);
    };
  }, []);

  return (
    <Grid
      css={css`
        padding: 0;
      `}
    >
      <GridCell phone={4} tablet={8} desktop={12}>
        {children}
      </GridCell>
    </Grid>
  );
};

export default AuthLayout;
